import { supabase } from '@/lib/supabaseClient'
import { OpenWorldPersistenceError } from '@/lib/openWorlds/persistence'

export async function requireOpenWorldSession(): Promise<void> {
  try {
    // This is a browser session-presence check, not an authorization decision.
    // The SDK refreshes expired tokens; database requests verify the token and
    // enforce RLS/RPC ownership. Do not add a getUser network preflight here.
    const { data, error } = await supabase.auth.getSession()
    if (error || !data.session?.access_token) {
      throw new OpenWorldPersistenceError('unauthenticated', 'Authentication is required.', { cause: error })
    }
  } catch (cause) {
    if (cause instanceof OpenWorldPersistenceError) throw cause
    throw new OpenWorldPersistenceError('unauthenticated', 'Authentication is required.', { cause })
  }
}
